import { Component, OnInit } from '@angular/core';
import { DataService } from '../../shared/services/data.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-hotjar',
  template: ``,
  standalone: true,
  imports: [ CommonModule ]
})
export class HotjarComponent implements OnInit {

  measurementId: string;

  constructor() {
    this.measurementId = DataService.hotjarId;
    this.embedHotjarScripts();
    if (window.opener) {
      window.opener.postMessage('started', '*');
      window.addEventListener('message', ($event) => {
        if (($event.origin.includes('localhost') || $event.origin.includes('admin-kla-')) && !$event.data.type) {
          this.measurementId = DataService.hotjarId;
          this.embedHotjarScripts();
        }
      });
    }
  }

  ngOnInit(): void {

  }

  embedHotjarScripts() {
    if (this.measurementId) {
      const el = document.createElement('script');
      el.innerHTML = `(function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:${this.measurementId},hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`;
      document.head.appendChild(el);
    }
  }

}
